declare global {
  interface Number {
    negativeToNull(): number | null;
  }
}

Number.prototype.negativeToNull = function(): number | null {
  const tmpNumber = Number(this);
  if (tmpNumber < 0) {
    return null
  } else {
    return tmpNumber
  }
}

declare global {
  interface Array<T> {
    realValuesOrEmpty(): T[];
  }
}

Array.prototype.realValuesOrEmpty = function() {
  return this.filter(item => {
    if (typeof item === 'number') {
      return item !== 0 && item !== -1;
    }

    return true;
  });
};

export {};
